import React from 'react';
import { Box, Text } from '@chakra-ui/core';
import { Cell } from 'react-table';
import { CandidateSearchResponseType } from '../CandidateSearchTypes';
import { formatPhoneNumber } from '../../../utils/PhoneUtils';

interface PhoneCellProps {
  cell: Cell<CandidateSearchResponseType>;
}

export const PhoneCell: React.FC<PhoneCellProps> = ({ cell }) => {
  const { phone, countryCode } = cell.row.original;
  return (
    <>
      {phone ? (
        <Box fontSize="14px" fontWeight={400} py="10px">
          {formatPhoneNumber(phone, countryCode || '', true)}
        </Box>
      ) : (
        <Text>-</Text>
      )}
    </>
  );
};
